export default function () {
    return {
        MuiTooltip: {
            tooltip: {
                fontSize: 14
            },
        }
    };
}